var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spaceCenter" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading || _vm.isNetworkLoading,
            expression: "loading || isNetworkLoading",
          },
        ],
        staticClass: "exchange-card",
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "exchange-tab-body" },
          [
            _c("div", { staticStyle: { position: "relative" } }, [
              _c(
                "div",
                {
                  staticClass: "network-container from-container",
                  class: { "switch-down": _vm.isNetworkSwitching },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "margin-bottom": ".11rem",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "word-sm",
                          staticStyle: { "line-height": "0 !important" },
                        },
                        [_vm._v("From：")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "unit-icon inline-block" }, [
                        _vm.fromType == "Ethereum"
                          ? _c("img", {
                              staticStyle: { width: "0.2rem" },
                              attrs: {
                                src: require("@/assets/image/transfer/eth.png"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fromType == "Treasurenet"
                          ? _c("img", {
                              staticStyle: { width: "0.2rem" },
                              attrs: {
                                src: require("@/assets/image/exchange/unit.png"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "padding-left": ".05rem" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-family":
                                    "HurmeGeometricSans2, HurmeGeometricSans2",
                                  "font-weight": "600",
                                  "font-size": ".22rem",
                                  color: "#fff",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.fromType) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "word-sm",
                          staticStyle: {
                            width: "100%",
                            "text-align": "right",
                            "font-weight": "normal",
                            "font-family":
                              "PlusJakartaDisplay-Medium, PlusJakartaDisplay",
                            color: "#929DAD !important",
                          },
                        },
                        [
                          _vm._v("\n              Balance :\n              "),
                          _vm.isBalanceLoading
                            ? [_c("i", { staticClass: "el-icon-loading" })]
                            : [
                                _c("big-number", {
                                  attrs: { number: _vm.balance },
                                  on: {
                                    "update:number": function ($event) {
                                      _vm.balance = $event
                                    },
                                  },
                                }),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "spaceBetween exchange-item",
                      staticStyle: {
                        display: "flex",
                        "padding-bottom": ".2rem !important",
                        "padding-top": ".32rem !important",
                        "flex-direction": "column",
                        width: "100%",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "1",
                            display: "flex",
                            "flex-direction": "column",
                            "align-items": "flex-end",
                            width: "100%",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "align-items": "center",
                                width: "100% !important",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "exchange-input",
                                staticStyle: { height: "100%" },
                                attrs: {
                                  placeholder: "0.00",
                                  onkeyup:
                                    "this.value=this.value.match(/\\d+\\.?\\d{0,18}/);",
                                },
                                on: { input: _vm.handleAmountInput },
                                model: {
                                  value: _vm.exchangeNum,
                                  callback: function ($$v) {
                                    _vm.exchangeNum = $$v
                                  },
                                  expression: "exchangeNum",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "spaceBetween",
                                  staticStyle: {
                                    "margin-bottom": "0.02rem",
                                    padding: "0 !important",
                                  },
                                },
                                [
                                  _c(
                                    "el-dropdown",
                                    {
                                      attrs: { trigger: "click" },
                                      on: {
                                        command: _vm.handleFromTokenChange,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "unit-icon inline-block",
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "0.22rem",
                                              "margin-right": "0.1rem",
                                            },
                                            attrs: {
                                              src: _vm.getTokenIcon(
                                                _vm.fromToken,
                                                _vm.fromType
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                flex: "1",
                                                display: "flex",
                                                "justify-content": "flex-end",
                                                "-webkit-justify-content":
                                                  "flex-end",
                                                "flex-direction": "row",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-family":
                                                      "PlusJakartaDisplay, PlusJakartaDisplay",
                                                    "font-size": ".22rem",
                                                    color: "#DCE0E7",
                                                    display: "flex",
                                                    "align-items": "center",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.fromTokenText
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-arrow-down",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        _vm._l(
                                          _vm.getAvailableFromTokens,
                                          function (token) {
                                            return _c(
                                              "el-dropdown-item",
                                              {
                                                key: token.symbol,
                                                attrs: { command: token },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "token-item" },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "0.22rem",
                                                        "margin-right":
                                                          "0.1rem",
                                                      },
                                                      attrs: {
                                                        src: _vm.getTokenIcon(
                                                          token.symbol,
                                                          _vm.fromType
                                                        ),
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(token.name)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("img", {
                staticClass: "exchange-jiantou",
                class: { "rotate-arrow": _vm.isNetworkSwitching },
                attrs: { src: require("@/assets/image/transfer/transfer.png") },
                on: { click: _vm.handleNetworkSwitch },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "network-container to-container",
                  class: { "switch-up": _vm.isNetworkSwitching },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "margin-bottom": ".11rem",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "word-sm",
                          staticStyle: { "line-height": "0 !important" },
                        },
                        [_vm._v("To：")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "unit-icon inline-block" }, [
                        _vm.toType == "Ethereum"
                          ? _c("img", {
                              staticStyle: { width: "0.2rem" },
                              attrs: {
                                src: require("@/assets/image/transfer/eth.png"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.toType == "Treasurenet"
                          ? _c("img", {
                              staticStyle: { width: "0.2rem" },
                              attrs: {
                                src: require("@/assets/image/exchange/unit.png"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "padding-left": ".05rem" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-family":
                                    "HurmeGeometricSans2, HurmeGeometricSans2",
                                  "font-weight": "600",
                                  "font-size": ".22rem",
                                  color: "#fff",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.toType) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "spaceBetween exchange-item",
                      staticStyle: {
                        display: "flex",
                        "padding-bottom": ".40rem !important",
                        "padding-top": ".40rem !important",
                        "flex-direction": "column",
                        width: "100% !important",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                            width: "100%",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "exchange-input",
                            attrs: {
                              placeholder: "0.00",
                              onkeyup:
                                "this.value=this.value.match(/\\d+\\.?\\d{0,18}/);",
                            },
                            on: { input: _vm.handleAmountInput },
                            model: {
                              value: _vm.exchangeNum,
                              callback: function ($$v) {
                                _vm.exchangeNum = $$v
                              },
                              expression: "exchangeNum",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "spaceBetween",
                              staticStyle: {
                                "margin-bottom": "0.02rem",
                                padding: "0 !important",
                              },
                            },
                            [
                              _c(
                                "el-dropdown",
                                {
                                  attrs: { trigger: "click" },
                                  on: { command: _vm.handleToTokenChange },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "unit-icon inline-block" },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "0.22rem",
                                          "margin-right": "0.1rem",
                                        },
                                        attrs: {
                                          src: _vm.getTokenIcon(
                                            _vm.toToken,
                                            _vm.toType
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "1",
                                            display: "flex",
                                            "justify-content": "flex-end",
                                            "-webkit-justify-content":
                                              "flex-end",
                                            "flex-direction": "row",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-family":
                                                  "PlusJakartaDisplay, PlusJakartaDisplay",
                                                "font-size": ".22rem",
                                                color: "#DCE0E7",
                                                display: "flex",
                                                "align-items": "center",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(_vm.toTokenText) +
                                                  "\n                        "
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-down",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    _vm._l(
                                      _vm.getAvailableToTokens,
                                      function (token) {
                                        return _c(
                                          "el-dropdown-item",
                                          {
                                            key: token.symbol,
                                            attrs: { command: token },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "token-item" },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "0.22rem",
                                                    "margin-right": "0.1rem",
                                                  },
                                                  attrs: {
                                                    src: _vm.getTokenIcon(
                                                      token.symbol,
                                                      _vm.toType
                                                    ),
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(_vm._s(token.name)),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "more" }, [
              _c(
                "div",
                {
                  staticClass: "moreText",
                  staticStyle: {
                    "font-family": "PlusJakartaDisplay, PlusJakartaDisplay",
                    "font-weight": "400",
                    "font-style": "normal",
                    "font-size": ".2rem",
                    color: "#DCE0E7",
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c("div", [_vm._v("\n            Bridge Fee\n          ")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "cost" }, [
                        _vm._v("\n              Fee："),
                        _c("span", [
                          _vm._v(_vm._s(_vm.numberValidateForm.bfAmount)),
                        ]),
                        _vm._v(_vm._s(_vm.fromToken) + "\n            "),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.isBalanceEnough
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#FF4D4F",
                      "font-size": ".2rem",
                      "margin-top": ".2rem",
                    },
                  },
                  [
                    _vm._v(
                      "\n        The Account Balance is insufficient to continue trading.\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("checkLoginBtn", {
              staticStyle: {
                "margin-top": "0.5rem",
                "font-family": "HurmeGeometricSans2, HurmeGeometricSans2",
                "font-weight": "600",
                "font-size": ".24rem",
                "font-style": "normal",
              },
              attrs: {
                label: "Start Bridging",
                disabled: _vm.isSubmitDisabled,
              },
              on: { clickHandle: _vm.submit },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "exchange-tab-box spaceCenter" }, [
      _c("img", {
        staticStyle: { width: "0.28rem", "margin-right": "0.12rem" },
        attrs: { src: require("@/assets/image/transfer/tansfer.png") },
      }),
      _vm._v("\n      TN Bridge\n    "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cost" }, [
      _vm._v("\n              Bridge Rate："),
      _c("span", [_vm._v("0.05")]),
      _vm._v("%\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }